export default {
  injuryImpact: {
    title: "Verletzungen",
    labels: {
      withoutPlayer: "Ohne {{player}}",
    },
    empty: {
      title: "Keine Verletzungen verfügbar",
    },
  },
};
